import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-34bc5c60"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-filtrate" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "filter-by" }, "Filter by : ", -1))
const _hoisted_3 = { class: "nest-relation" }
const _hoisted_4 = { class: "price-prodict" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Price ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode()
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, "-", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "frame-border" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "frame-border" }, null, -1))
const _hoisted_10 = { class: "on-off" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_unwind = _resolveComponent("unwind")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_servicer = _resolveComponent("servicer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      ($setup.categoryList.length > 0)
        ? (_openBlock(), _createBlock(_component_unwind, _mergeProps({
            key: 0,
            transferData: $setup.categoryList,
            ref: "refsUnwind"
          }, _ctx.$attrs, {
            headline: "Category",
            radioCheck: true,
            unActive: $setup.unCategory
          }), null, 16, ["transferData", "unActive"]))
        : _createCommentVNode("", true),
      ($setup.brandList.length >= 0)
        ? (_openBlock(), _createBlock(_component_unwind, _mergeProps({
            key: 1,
            transferData: $setup.brandList,
            ref: "refsUnwindTow"
          }, _ctx.$attrs, {
            headline: "Brand",
            radioCheck: true,
            unActive: $setup.unBrand
          }), null, 16, ["transferData", "unActive"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", null, [
          _createVNode(_component_van_field, {
            class: "price_field",
            modelValue: $setup.modelMix,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.modelMix) = $event)),
            placeholder: "mix",
            type: "digit"
          }, null, 8, ["modelValue"]),
          _hoisted_6,
          _hoisted_7,
          _createVNode(_component_van_field, {
            class: "price_field",
            modelValue: $setup.modelMax,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.modelMax) = $event)),
            placeholder: "max",
            onBlur: $setup.modelMaxClick,
            type: "digit"
          }, null, 8, ["modelValue", "onBlur"])
        ])
      ]),
      _hoisted_8,
      _createVNode(_component_servicer, _mergeProps({
        transferData: $props.shipped,
        radioCheck: true,
        headline: "Shipped From"
      }, _ctx.$attrs, { ref: "refShipped" }), null, 16, ["transferData"]),
      _hoisted_9,
      _createVNode(_component_servicer, _mergeProps({
        transferData: $setup.serviceList,
        radioCheck: false,
        headline: "Service"
      }, _ctx.$attrs, { ref: "refService" }), null, 16, ["transferData"])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("span", {
        onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.cloneClick('Reset')))
      }, "Reset"),
      _createElementVNode("span", {
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.cloneClick && $setup.cloneClick(...args)))
      }, "Apply")
    ])
  ]))
}